module.exports = __webpack_public_path__ + "img/success_wxim.65516861.png";